import React from 'react';
import PropTypes from 'prop-types';

// Context
import { useAuth } from '../../../contexts';

// components
import Header from '../../components/Header/Header';

const Page = ({ page, children, showBackButton, onBack }) => {
  const { signOut, user } = useAuth();

  const onLogoutClick = () => signOut();

  return (
    <>
      <Header 
        user={user?.name || 'Porsche PIA KOPER'} 
        onLogout={onLogoutClick}
        showBackButton={showBackButton}
        onBack={onBack}
      />
      {children}
    </>
  );
};

Page.propTypes = {
  page: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showBackButton: PropTypes.bool,
  onBack: PropTypes.func,
};

export default Page;
